import React from 'react'
import tw from "twin.macro";
import styled from "styled-components";

import  ms_identity  from "../../../Images/ms_identity.png";
import  ms_active from "../../../Images/ms_active.png";
import okta from "../../../Images/okta.jpg";
import auth from "../../../Images/auth_logo.jpg";
import aws from "../../../Images/aws_cog.jpg"
import google from "../../../Images/google.jpg"

const Column = tw.div`w-full max-w-md mx-auto md:max-w-none md:mx-0`;
// const Card = tw.div`flex flex-col md:flex-row justify-center max-w-screen-xl mx-auto my-5 border-2 rounded-xl border-blue-100	`;
const Card = tw.div`flex flex-col md:flex-row justify-center max-w-screen-xl mx-auto mb-5`;
const ImageRow = tw.div`flex  flex-wrap md:flex-row justify-center items-center max-w-screen-xl mx-auto pt-0 pb-0`;
const ImageSpan = tw.span`lg:mx-5 md:mx-5 sm:mx-5 ml-1 mr-1`;
const ImageColumn2 = tw(
  Column
)`w-10 p-0 sm:p-3 sm:w-24 lg:p-2 mb-5 mt-3 lg:w-40 md:w-24 md:p-2 xs:w-18 xs:p-0 items-end sm:items-start xs:items-start`;
const Image = styled.img((props) => [
  props.imageRounded && tw`rounded`,
  props.imageBorder && tw`border`,
  props.imageShadow && tw`shadow`,
  tw(
    Column
  )` w-32 p-4 sm:p-3 sm:w-24 lg:p-4 my-5 lg:w-32 md:w-24 md:p-3 xs:w-12 xs:p-1`,
]);
const Title = tw.p`-mt-4 text-sm text-center xs:mx-auto`;
const Container = tw.div`pb-1 w-full text-center `;
const Heading = tw.h5`md:text-xl text-lg font-bold text-gray-900 px-8`;
const SubHeading = tw.p`text-base text-gray-700 sm:text-lg`;

let cards = {
    heading: "We utilize industry leading platforms like AWS Cognito, Okta, Microsoft Identity Manager, Active Directory, Auth0 and Google for our CIAM services.",
  subheading: "Seamlessly integrate customer identity & access management solutions into your digital infrastructure."
}

const CIAMLogoCard = () => {


  let  imageSrc1 = ms_identity,
        imageSrc2 = ms_active,
        imageSrc3 = okta,
        imageSrc4 = auth,
        imageSrc5 = aws,
        imageSrc6 = google,
        imageRounded = true,
        imageBorder = false,
        imageShadow = false
  return (
        
    <Card>
    <Container >
       <ImageRow>
        <ImageSpan>
        <ImageColumn2>
            <Image
                src={imageSrc5}
                imageBorder={imageBorder}
                imageShadow={imageShadow}
                imageRounded={imageRounded}
                alt="aws"
            />
        </ImageColumn2>
        </ImageSpan>
        <ImageSpan>
            <ImageColumn2>
                <Image
                    src={imageSrc3}
                    imageBorder={imageBorder}
                    imageShadow={imageShadow}
                    imageRounded={imageRounded}
                    alt="okta"
                />
            </ImageColumn2>
        </ImageSpan>
        <ImageSpan>
           <ImageColumn2>
             <Image
              src={imageSrc1}
              imageBorder={imageBorder}
              imageShadow={imageShadow}
              imageRounded={imageRounded}
              alt="ms_identity"
            />
          </ImageColumn2>
        </ImageSpan>
        <ImageSpan>
          <ImageColumn2>
          <Image
              style={{height:"80px"}}
              src={imageSrc2}
              imageBorder={imageBorder}
              imageShadow={imageShadow}
              imageRounded={imageRounded}
              alt="ms_active"
            />
          </ImageColumn2>
        </ImageSpan>

        <ImageSpan>
          <ImageColumn2>
            <Image
              src={imageSrc4}
              imageBorder={imageBorder}
              imageShadow={imageShadow}
              imageRounded={imageRounded}
              alt="auth"
            />
          </ImageColumn2>
        </ImageSpan>

        <ImageSpan>
          <ImageColumn2>
            <Image
              src={imageSrc6}
              imageBorder={imageBorder}
              imageShadow={imageShadow}
              imageRounded={imageRounded}
              alt="google"
            />
          </ImageColumn2>
        </ImageSpan>
        
      </ImageRow>
      <Heading>
       {cards.heading}
      </Heading>
      <SubHeading >
      {cards.subheading}
      </SubHeading>
    </Container>
  </Card>
  )
}

export default CIAMLogoCard